module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-4"
  }, [(_vm.wSat == 1) ? _c('MainTabs', {
    attrs: {
      "cancelFlag": _vm.cancelFlag,
      "pressType": _vm.typeLst,
      "pressDat": _vm.resDat,
      "role": "press",
      "organization": _vm.organization
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4653325c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/skimFrame.vue
// module id = 1728
// module chunks = 1